/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon/core/subtasks';
import ObjectBase from '../object-base';
export default function SubtaskObject(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Subtask' : _ref$label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ObjectBase, {
    label: label,
    size: size,
    testId: testId,
    icon: IconComponent,
    color: "var(--ds-icon-accent-blue, #1D7AFC)"
  });
}